if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function ($) {
    var fwSliderEl = document.querySelector('.fw-product-slider');
    if (fwSliderEl) {
      var checkSplideFw = setInterval(function () {
        if (typeof Splide !== 'undefined') {
          clearInterval(checkSplideFw);
          new Splide(fwSliderEl, {
            type: 'loop',
            drag: 'free',
            perPage: 2,
            pagination: false,
            arrows: false,
            gap: '10px',
            autoScroll: {
              speed: 0.5,
              pauseOnHover: true,
              pauseOnFocus: false,
            }
          }).mount(window.splide ? window.splide.Extensions : window.splide);
          fwSliderEl.style.visibility = 'visible';
        }
      }, 100);
    }

    if ($('.fw-modal-slider').length) {
      $('.fw-modal-slider').slick({
        slidesToShow: 1,
        infinite: true,
        arrows: true,
        dots: false,
      });

      $('.fw-modal-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        resetFwModalZoom();
        $(slick.$slides[currentSlide]).find('video').each(function () {
          this.pause();
        });
      });

      $('.fw-modal-slider').on('afterChange', function (event, slick, currentSlide) {
        var vid = $(slick.$slides[currentSlide]).find('video').get(0);
        if (vid) {
          vid.play().catch(function () {});
        }
      });
    }

    var fwModalZoomBounds = new WeakMap();

    function resetFwModalZoom() {
      $('#fw-image-modal .fw-modal-slider img').each(function () {
        fwModalZoomBounds.delete(this);
        this.classList.remove('fw-image-zoomed');
        this.style.transform = '';
        this.style.transformOrigin = '';
      });
    }

    function updateFwModalZoom(image, event) {
      var imageBounds = fwModalZoomBounds.get(image);
      if (!imageBounds) return;

      var imageWidth = imageBounds.width;
      var imageHeight = imageBounds.height;
      if (!imageWidth || !imageHeight) return;

      var xPercent = Math.min(100, Math.max(0, ((event.clientX - imageBounds.left) / imageWidth) * 100));
      var yPercent = Math.min(100, Math.max(0, ((event.clientY - imageBounds.top) / imageHeight) * 100));

      image.style.transformOrigin = xPercent + '% ' + yPercent + '%';
      image.style.transform = 'scale(2)';
    }

    $(document)
      .on('click', '#fw-image-modal .fw-modal-slider img', function (event) {
        if (this.classList.contains('fw-image-zoomed')) {
          fwModalZoomBounds.delete(this);
          this.classList.remove('fw-image-zoomed');
          this.style.transform = '';
          this.style.transformOrigin = '';
          return;
        }

        fwModalZoomBounds.set(this, this.getBoundingClientRect());
        this.classList.add('fw-image-zoomed');
        updateFwModalZoom(this, event);
      })
      .on('mousemove', '#fw-image-modal .fw-modal-slider img', function (event) {
        if (this.classList.contains('fw-image-zoomed')) {
          updateFwModalZoom(this, event);
        }
      });

    var isDragging = false;
    var startX = 0, startY = 0;

    $(document).on('mousedown', '.fw-product-slider .fw-product-slide', function (e) {
      startX = e.pageX;
      startY = e.pageY;
      isDragging = false;
    });

    $(document).on('mousemove', '.fw-product-slider .fw-product-slide', function (e) {
      if (Math.abs(e.pageX - startX) > 6 || Math.abs(e.pageY - startY) > 6) {
        isDragging = true;
      }
    });

    $(document).on('mouseup', '.fw-product-slider .fw-product-slide', function (e) {
      if (!isDragging) {
        var index = $(this).data('index');
        if (typeof index === 'undefined') {
          index = $(this).find('[data-index]').data('index');
        }
        var modal = $('#fw-image-modal');
        if (modal.length && typeof index !== 'undefined') {
          modal.fadeIn(200, function () {
            $('.fw-modal-slider').slick('setPosition');
          });
          $('body').addClass('open-fw-image-modal');
          $('.fw-modal-slider').slick('slickGoTo', index, true);
          $('.fw-modal-slider').slick('setPosition');

          var currentSlide = $('.fw-modal-slider .slick-current');
          var vid = currentSlide.find('video').get(0);
          if (vid) {
            vid.currentTime = 0;
            vid.play().catch(function () {});
          }
        }
      }
    });

    // Close modal
    $('.fw-modal .fw-close').click(function () {
      resetFwModalZoom();
      $('#fw-image-modal').fadeOut();
      $('body').removeClass('open-fw-image-modal');
      $('.fw-modal-slider video').each(function () {
        this.pause();
      });
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $('#fw-image-modal').is(':visible')) {
        resetFwModalZoom();
        $('#fw-image-modal').fadeOut();
        $('body').removeClass('open-fw-image-modal');
        $('.fw-modal-slider video').each(function () {
          this.pause();
        });
      }
    });
  });
}

if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function ($) {
    if (document.body.classList.contains("fw-global-drawer-page")) {
      const globalMenu = document.querySelector("sticky-header.header-wrapper #menu");
      if (globalMenu) document.body.appendChild(globalMenu);
    }

    $("#mobileMenuToggle").on("click", function () {
      const globalMenuToggle = document.getElementById("menuToggle");
      if (globalMenuToggle) globalMenuToggle.click();
    });

    $(document).on("click", ".fw-global-drawer-close", function () {
      const globalMenuToggle = document.getElementById("menuToggle");
      if (globalMenuToggle) globalMenuToggle.click();
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {

  const reworkedPdpSlider = document.getElementById('reworked_pdp_slider');

  if (reworkedPdpSlider) {
    // Check periodically for Splide to ensure it has loaded
    var checkSplidePdp = setInterval(function () {
      if (typeof Splide !== 'undefined') {
        clearInterval(checkSplidePdp);
        new Splide('#reworked_pdp_slider', {
          type: 'loop',
          drag: 'free',
          autoWidth: true,
          pagination: false,
          arrows: false,
          gap: '10px',
          autoScroll: {
            speed: 0.5,
            pauseOnHover: true,
            pauseOnFocus: false,
          }
        }).mount(window.splide.Extensions);
        reworkedPdpSlider.style.visibility = 'visible';
      }
    }, 100);
  }

  // Modal popup functionality
  const modal = document.getElementById('imageModal');
  const modalImg = document.getElementById('modalImg');
  const closeModal = document.getElementById('closeModal');

  if (!modal || !modalImg || !closeModal) return;

  document.querySelectorAll('.slider-image').forEach(img => {
    img.addEventListener('click', () => {
      modal.style.display = 'flex';
      modalImg.src = img.src;
      document.body.classList.add('open-fw-image-modal');
    });
  });

  closeModal.addEventListener('click', () => {
    modal.style.display = 'none';
    modalImg.src = '';
    document.body.classList.remove('open-fw-image-modal');
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
      modalImg.src = '';
      document.body.classList.remove('open-fw-image-modal');
    }
  });

});

window.initFbtSlickSlider = function () {
  if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick) {
    jQuery('.frequently_bought_together_block:not(.also-bought-together) .frequently_bought_products').each(function () {
      var $this = jQuery(this);
      if (!$this.hasClass('slick-initialized') && $this.children('.product-variant-card').length > 0) {
        $this.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          speed: 800,
          cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
          infinite: true,
          arrows: false,
          pauseOnHover: true,
          pauseOnFocus: false,
          swipeToSlide: true,
          touchThreshold: 20,
          useTransform: true,
          responsive: [
            {
              breakpoint: 749,
              settings: {
                slidesToShow: 2,
                swipeToSlide: true
              }
            }
          ]
        });
      }
    });
  }
};

window.initCartDrawerSlick = function () {
  if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick) {
    jQuery('.also-bought-together .frequently_bought_products').each(function () {
      var $this = jQuery(this);
      if ($this.children('.product-variant-card').length > 1) {
        if (!$this.hasClass('slick-initialized')) {
          $this.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            autoplay: false,
            swipeToSlide: true,
            swipe: true,
            touchMove: true,
            draggable: true,
            touchThreshold: 10,
            speed: 400
          });
        } else {
          $this.slick('setPosition');
        }
      }
    });
  }
};

window.initCartTrustRotator = function (force) {
  var rotators = document.querySelectorAll('.cart-trust-badges-rotator');
  rotators.forEach(function (rotator) {
    if (!force && rotator._rotatorInterval && document.body.contains(rotator)) {
      return;
    }
    if (rotator._rotatorInterval) {
      clearInterval(rotator._rotatorInterval);
      rotator._rotatorInterval = null;
    }

    var items = rotator.querySelectorAll('.cart-trust-badge-item');
    if (items.length <= 1) return;

    var currentIndex = 0;
    var activeFound = false;
    items.forEach(function (item, idx) {
      if (item.classList.contains('active')) {
        currentIndex = idx;
        activeFound = true;
      }
    });

    if (!activeFound && items.length > 0) {
      items[0].classList.add('active');
      currentIndex = 0;
    }

    rotator.dataset.rotatorInitialized = 'true';

    rotator._rotatorInterval = setInterval(function () {
      if (!document.body.contains(rotator)) {
        clearInterval(rotator._rotatorInterval);
        rotator._rotatorInterval = null;
        return;
      }

      var liveItems = rotator.querySelectorAll('.cart-trust-badge-item');
      if (liveItems.length <= 1) return;

      var prevIndex = currentIndex;
      currentIndex = (currentIndex + 1) % liveItems.length;

      liveItems.forEach(function (item, idx) {
        if (idx === currentIndex) {
          item.classList.add('active');
          item.classList.remove('exit');
        } else if (idx === prevIndex) {
          item.classList.remove('active');
          item.classList.add('exit');
          setTimeout(function () {
            if (item) item.classList.remove('exit');
          }, 1000);
        } else {
          item.classList.remove('active', 'exit');
        }
      });
    }, 3500);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { window.initCartTrustRotator(true); });
} else {
  window.initCartTrustRotator(true);
}
window.addEventListener('load', function () { window.initCartTrustRotator(true); });

// MutationObserver fallback to auto-initialize trust rotators whenever added to DOM
if (typeof MutationObserver !== 'undefined' && !window._cartTrustRotatorObserver) {
  window._cartTrustRotatorObserver = new MutationObserver(function (mutations) {
    var needsInit = false;
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.addedNodes && mutation.addedNodes.length) {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('cart-trust-badges-rotator')) {
              needsInit = true;
              break;
            }
            if (node.querySelector && node.querySelector('.cart-trust-badges-rotator')) {
              needsInit = true;
              break;
            }
          }
        }
      }
      if (needsInit) break;
    }
    if (needsInit) {
      window.initCartTrustRotator(true);
    }
  });

  if (document.body) {
    window._cartTrustRotatorObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.body) {
        window._cartTrustRotatorObserver.observe(document.body, { childList: true, subtree: true });
      }
    });
  }
}

if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function ($) {
    window.initFbtSlickSlider();
    window.initCartDrawerSlick();
    window.initCartTrustRotator();



    if ($(window).width() < 767) {
      if ($('.shop_the_look_products').length > 0) {
        $('.shop_the_look_products').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          speed: 1000,
          cssEase: 'ease',
          infinite: true,
          arrows: false,
          pauseOnHover: true,
          pauseOnFocus: false,
        });
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains('template-product.fw-bundle')) return;

  const variantBlocks = document.querySelectorAll(".custom-variant-product");
  if (!variantBlocks.length) return;

  variantBlocks.forEach(block => {
    // FW labels contain separate "Color" and current-color spans. Update only
    // the current-color value on hover; changing the first span replaces the
    // fixed label and can leave it wrong after navigating to another color.
    const colorTextEl = block.querySelector(".fw-color-variant-label span:last-child")
      || block.querySelector("p span");
    if (!colorTextEl) return;

    const defaultColorName = colorTextEl.textContent.trim();
    const variantLinks = block.querySelectorAll(".custom-variant-image a");
    if (!variantLinks.length) return;

    variantLinks.forEach(link => {
      const hoverName = link.getAttribute("data-color-name");
      if (!hoverName) return;

      link.addEventListener("mouseenter", () => {
        colorTextEl.textContent = hoverName;
      });

      link.addEventListener("mouseleave", () => {
        colorTextEl.textContent = defaultColorName;
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {

  function initSizeChartPopup(modalId, openBtnSelectors) {
    var modal = document.getElementById(modalId);
    if (!modal) return;

    var closeBtn = modal.querySelector(".close-btn");

    var targetSelectors = [];
    openBtnSelectors.forEach(selector => {
      targetSelectors.push(selector);
      if (selector.startsWith("#")) {
        targetSelectors.push(`a[href="${selector}"]`);
        targetSelectors.push(`[data-target="${selector}"]`);
        targetSelectors.push(`[data-open="${selector}"]`);
      }
    });
    targetSelectors.push(`a[href="#${modalId}"]`);
    targetSelectors.push(`[data-target="#${modalId}"]`);

    var combinedSelector = targetSelectors.join(", ");

    function openModal(e) {
      if (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (e._sizePopupHandled) return;
        e._sizePopupHandled = true;
      }
      modal.style.display = "flex";
      setTimeout(() => {
        document.body.classList.add('cs-popup-is-opened');
      }, 50);
    }

    // Attach open button events to all existing matching elements
    document.querySelectorAll(combinedSelector).forEach(btn => {
      btn.addEventListener("click", openModal);
    });

    // Delegate click events for dynamic elements and anchor links
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest(combinedSelector);
      if (trigger) {
        openModal(e);
      }
    });

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        document.body.classList.remove('cs-popup-is-opened');
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      });
    }

    // Click outside to close
    window.addEventListener("click", function (event) {
      if (event.target === modal) {
        document.body.classList.remove('cs-popup-is-opened');
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      }
    });
  }

  // Initialize both popups
  initSizeChartPopup("cspopupModal1", ["#openPopupBtn1", "#sizeBtnPopup"]);
  initSizeChartPopup("cspopupModal2", ["#openPopupBtn2", "#sizeBtnPopup"]);
  initSizeChartPopup("cspopupModal", ["#openPopupBtn", "#sizeBtnPopup"]);
});

(function () {
  var reels = document.querySelectorAll(".reel");
  var thumbs = document.querySelectorAll(".thumb");
  if (!reels.length) return;
  var currentIndex = 0;
  var isMobile = window.matchMedia("(max-width: 768px)").matches;
  if (!isMobile) {
    reels.forEach(function (reel) {
      var video = reel.querySelector("video");
      if (!video) return;
      video.play().catch(function () { });
      video.loop = true;
    });
  }
  if (isMobile) {
    function playReel(index) {
      reels.forEach(function (reel, i) {
        var video = reel.querySelector("video");
        if (!video) return;

        reel.classList.toggle("active", i === index);
        if (thumbs[i]) thumbs[i].classList.toggle("active", i === index);

        video.pause();
        video.currentTime = 0;

        if (i === index) {
          video.play().catch(function () { });
          video.onended = function () { nextReel(); };
        }
      });
    }

    function nextReel() {
      currentIndex = (currentIndex + 1) % reels.length;
      playReel(currentIndex);
    }

    playReel(currentIndex);

    // Thumbnail click
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        currentIndex = index;
        playReel(currentIndex);
      });
    });
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (!targetId || targetId === "#" || /Popup|Modal|size|drawer/i.test(targetId)) return;

      const targetEl = document.querySelector(targetId);
      if (!targetEl) return;

      e.preventDefault();

      const offset = 100; // 👈 TOP OFFSET
      const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  });
});
if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function ($) {
    if (document.getElementById('slider_splide')) {
      // Check periodically for Splide since it might load slightly after theme-custom.js
      var checkSplide = setInterval(function () {
        if (typeof Splide !== 'undefined' && typeof window.splide !== 'undefined' && window.splide.Extensions) {
          clearInterval(checkSplide);
          new Splide('#slider_splide', {
            type: 'loop',
            drag: 'free',
            autoWidth: true,
            pagination: false,
            arrows: false,
            direction: 'rtl',
            gap: '64px',
            autoScroll: {
              speed: 0.5,
              pauseOnHover: true,
              pauseOnFocus: false,
            },
          }).mount(window.splide.Extensions);
        }
      }, 100);
    }

    if ($('.myReviewSwiper .slick-review-wrapper').length) {
      $('.myReviewSwiper .slick-review-wrapper').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 4 } },
          { breakpoint: 640, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1.2 } }
        ]
      });
    }
  });
}

// USP title case change

document.querySelectorAll('.USP_title').forEach(el => {
  const text = el.textContent.toLowerCase();
  el.textContent = text.charAt(0).toUpperCase() + text.slice(1);
});

// Handle Add to Bag for Frequently Bought Together items
document.addEventListener('click', function (e) {
  const fbtBtn = e.target.closest('.fbt-add-btn');
  if (fbtBtn) {
    e.preventDefault();
    const variantId = fbtBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    fbtBtn.classList.add('loading');
    fbtBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(response => response.json())
      .then(cart => {
        fbtBtn.classList.remove('loading');
        fbtBtn.disabled = false;

        if (typeof refreshCart === 'function') {
          refreshCart();
        }

        const drawerEl = document.querySelector('new-cart-drawer');
        if (drawerEl) {
          drawerEl.classList.add('active', 'animate');
          document.body.classList.add('overflow-hidden');
        }
      })
      .catch(err => {
        console.error('Error adding FBT item:', err);
        fbtBtn.classList.remove('loading');
        fbtBtn.disabled = false;
      });
  }
});


// Close size chart popup when clicking outside (overlay) or pressing ESC
document.addEventListener('click', function (e) {
  if (e.target.classList.contains('size-chart-popup-overlay') || e.target.id === 'size-chart-popup-overlay') {
    if (typeof window.closeVariantPopup === 'function') {
      window.closeVariantPopup();
    }
  }
});
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    var overlay = document.querySelector('.size-chart-popup-overlay');
    if (overlay && overlay.classList.contains('show')) {
      if (typeof window.closeVariantPopup === 'function') {
        window.closeVariantPopup();
      }
    }
  }
});
